<template>
  <div class="admin-container">
    <h1 class="admin-title">答题管理后台</h1>

    <div class="control-panel">
      <button
        @click="toggleQuizState"
        :class="['control-button', { 'active': isQuizActive }]"
      >
        {{ isQuizActive ? '关闭抢答' : '开放抢答' }}
      </button>
    </div>

    <!-- Real-time answer list -->
    <div v-if="isQuizActive && answerList.length > 0" class="answer-list-section">
      <h2>实时抢答名单</h2>
      <div class="answer-list">
        <div
          v-for="(user, index) in displayAnswerList"
          :key="index"
          class="answer-item"
        >
          <span class="rank">{{ index + 1 }}</span>
          <span class="name">{{ user.name }}</span>
          <span class="time">{{ user.time }}ms</span>
        </div>
      </div>
    </div>

    <!-- Final result list -->
    <div v-if="!isQuizActive && fastestThree.length > 0" class="ranking-section">
      <h2>最快抢答者</h2>
      <div class="ranking-list">
        <div
          v-for="(user, index) in fastestThree"
          :key="index"
          class="ranking-item"
        >
          <span class="rank">{{ index + 1 }}</span>
          <span class="name">{{ user.name }}</span>
          <span class="time">{{ user.time }}ms</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminView',
  data() {
    return {
      socket: null,
      isQuizActive: false,
      fastestThree: [],
      answerList: []
    };
  },
  computed: {
    displayAnswerList() {
      return this.answerList.slice(0, 5); // Only show first 5 answers
    }
  },
  created() {
    this.initializeWebSocket();
  },
  methods: {
    initializeWebSocket() {
      this.socket = new WebSocket('wss://ws.jixiangjiaoyu.com');

      this.socket.onopen = () => {
        console.log('Admin WebSocket connected');
        // Register as admin
        this.socket.send(JSON.stringify({
          type: 'register',
          role_name: 'Admin',
          is_admin: true
        }));
      };

      this.socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        console.log('Admin received message:', message);

        switch (message.type) {
          case 'state':
            this.isQuizActive = message.data.isActive;
            this.fastestThree = message.data.fastestThree || [];
            break;
          case 'answer':
            // Add new answer to the list with timestamp
            if (this.isQuizActive) {
              const answer = message.data.answer;
              this.answerList.push({
                name: answer.name,
                time: answer.time
              });
              // Sort by time
              this.answerList.sort((a, b) => a.time - b.time);
              // Update fastest three
              this.fastestThree = message.data.fastestThree;
            }
            break;
          case 'stop':
            this.isQuizActive = false;
            this.fastestThree = message.data.fastestThree;
            break;
          case 'start':
            this.isQuizActive = true;
            this.fastestThree = [];
            this.answerList = [];
            break;
        }
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    },
    toggleQuizState() {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.isQuizActive = !this.isQuizActive;
        this.socket.send(JSON.stringify({
          type: this.isQuizActive ? 'start' : 'stop'
        }));

        if (this.isQuizActive) {
          // Clear lists when starting new round
          this.fastestThree = [];
          this.answerList = [];
        }
      }
    }
  }
};
</script>

<style scoped>
.admin-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.admin-title {
  text-align: center;
  color: #2d3748;
  margin-bottom: 40px;
  font-size: 24px;
}

.control-panel {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.control-button {
  padding: 16px 32px;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  background-color: #4299e1;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.control-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.control-button.active {
  background-color: #48bb78;
}

.answer-list-section,
.ranking-section {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.answer-list-section h2,
.ranking-section h2 {
  text-align: center;
  color: #2d3748;
  margin-bottom: 20px;
  font-size: 20px;
}

.answer-list,
.ranking-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.answer-item,
.ranking-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: #f7fafc;
  border-radius: 8px;
  transition: transform 0.2s;
}

.answer-item {
  border-left: 4px solid #48bb78;
}

.answer-item:hover,
.ranking-item:hover {
  transform: translateX(4px);
}

.rank {
  font-size: 18px;
  font-weight: 600;
  color: #4a5568;
  width: 40px;
}

.name {
  flex: 1;
  font-size: 16px;
  color: #2d3748;
}

.time {
  color: #718096;
  font-size: 14px;
}
</style>
